<template>
  <div class="message-background">
    <div class="title-resume mb-3">Mensagem do Organizador</div>
    <div v-html="organizerInfo.mensagem"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  computed: {
    organizerInfo() {
      return this.$store.getters.postOrder;
    },
  },
};
</script>

<style scoped>
.message-background {
  background: #F1F7FD;
  border-radius: 8px;
  padding: 20px;
}
.title-resume {
  color: var(--v-primary-base) !important;
    line-height: normal !important;
    font-size: 18px !important;
    width: 89%;
} 
    
</style>